// RoleBasedRedirect.tsx - Componente para redirigir según rol del usuario
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../shared/hooks/useAuth';

const RoleBasedRedirect = () => {
    const { user, userData, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) return;

        if (!userData) {
            // Sesión iniciada pero el rol aún no llega: esperar (antes mandaba al login y parpadeaba)
            if (user) return;
            // Sin sesión: al login
            navigate('/login', { replace: true });
            return;
        }

        // Redirigir según el rol del usuario
        switch (userData.role) {
            case 'super_admin':
                navigate('/super-admin', { replace: true });
                break;
            case 'admin':
            case 'operator':
            case 'supervisor':
                navigate('/dashboard', { replace: true });
                break;
            case 'agent':
                navigate('/agent/dashboard', { replace: true });
                break;
            case 'branch_agent':
                navigate('/branch/dashboard', { replace: true });
                break;
            case 'client':
                navigate('/client/dashboard', { replace: true });
                break;
            case 'courier':
                navigate('/courier/dashboard', { replace: true });
                break;
            default:
                navigate('/dashboard', { replace: true });
        }
    }, [user, userData, loading, navigate]);

    // Mostrar loading mientras se obtienen los datos
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#f3f4f6'
        }}>
            <div style={{
                width: '48px',
                height: '48px',
                border: '4px solid #e5e7eb',
                borderTopColor: '#E50914',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
            }} />
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default RoleBasedRedirect;
